import i18n from "@/i18n";
import { DeclarationPropertiesTypes } from "../../data/enums/declarationPropertiesTypes";
import { OperationRequestData } from "../../data/operationRequestData";
import { OperationModel } from "../operations/operationModel";
import { ContractModel } from "../contracts/contractModel";
import { CardModel } from "../contracts/cardModel";

/** Модель выбора категории CashBack */
export class CashBackCategoryModel extends OperationModel {
  
  public selectedCategory: string = "";
  public contract: ContractModel = new ContractModel();
  public card: CardModel = new CardModel();

  constructor(src: any) {
    super();
    this.contract = src.contract;
    this.card = src.card;
  }

  /**
   * Создание запроса операции.
   */
  public createOperationRequest(): OperationRequestData {
    const ord = new OperationRequestData();
    ord.respondentCode = this.RespondentCode;
    ord.operationId = this.OperationId;

    ord.setProperty("category", this.selectedCategory, DeclarationPropertiesTypes.String);
    ord.setProperty("contract", this.contract.Data.ReferenceId, DeclarationPropertiesTypes.String);
    ord.setProperty("card", this.card.Data.ReferenceId, DeclarationPropertiesTypes.String);

    return ord;
  }

  /**
   * Заполнение операции данными из ответа запроса.
   * @param ord Данные запроса.
   * @param bAssign Признак assign.
   */
  public setOperationFromRequest(...args: any[]): void {
    console.log("No implemetation");
  }
}
